function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export default (function (_ref) {
  var colors = _ref.colors,
      mediaQueries = _ref.mediaQueries;
  return {
    container: _defineProperty({
      padding: '15px 15px 0 15px',
      marginBottom: '30px'
    }, mediaQueries.breakpointLarge, {
      padding: '0'
    }),
    description: {
      fontSize: '15px',
      color: colors.mediumGray,
      marginBottom: '25px'
    },
    formInnerWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    formControl: {
      maxWidth: '320px',
      textAlign: 'left'
    }
  };
});